import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NuevoMovimiento from "@/pages/NuevoMovimiento";
import Historial from "@/pages/Historial";
import Camiones from "@/pages/Camiones";
import Conductores from "@/pages/Conductores";
import Reportes from "@/pages/Reportes";
import Transito from "@/pages/Transito";
import Admin from "@/pages/Admin";
import TVView from "@/pages/TVView";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-navy" data-testid="auth-loading">
      <div className="w-10 h-10 border-3 border-telemetry border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function Protected({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role === "tv" && location.pathname !== "/tv") return <Navigate to="/tv" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) return <Navigate to={user.role === "tv" ? "/tv" : "/"} replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/tv" element={<Protected><TVView /></Protected>} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/registro" element={<NuevoMovimiento />} />
              <Route path="/historial" element={<Historial />} />
              <Route path="/camiones" element={<Camiones />} />
              <Route path="/conductores" element={<Conductores />} />
              <Route path="/reportes" element={<Reportes />} />
              <Route path="/transito" element={<Transito />} />
              <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
